import { render, staticRenderFns } from "./Event_Tags_Component.vue?vue&type=template&id=2b17309e&scoped=true"
import script from "./Event_Tags_Component.vue?vue&type=script&lang=js"
export * from "./Event_Tags_Component.vue?vue&type=script&lang=js"
import style0 from "./Event_Tags_Component.vue?vue&type=style&index=0&id=2b17309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17309e",
  null
  
)

export default component.exports